// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  bottom: 0;
  width: 100%;
  background-color: var(--background);
  padding: 1rem;
  border-top: 2px solid var(--mid-gray);
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: var(--text-color);
}
.footer h4 {
  text-align: center;
  font-size: 10px;
  margin: 10px 0 0 0;
}
.footer svg {
  padding: 4px;
}
.footer svg path {
  fill: var(--text-color);
}
.footer .footer-content-container {
  width: 70%;
  margin: auto;
}
.footer .footer-content-container .fxLayout-row-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.footer .footer-content-container .fxLayout-row-wrap .fxLayout-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 100%;
  flex: 1;
}
.footer .footer-content-container .fxLayout-row-wrap .fxLayout-column .best-logo {
  width: 80%;
  width: 197.75px !important;
  height: 102.8px !important;
}
.footer .footer-content-container .fxLayout-row-wrap .fxLayout-column .inside-column-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.footer mat-icon {
  margin: 0 0.5rem;
  vertical-align: middle;
}
.footer img {
  width: 50%;
  height: 50%;
}
.footer .divider-h-spacing {
  margin: 0 5rem;
}
.footer .divider-v-spacing {
  border: 1px solid var(--mid-gray);
  border-radius: 2px;
  margin-top: 10px;
}
.footer span {
  text-align: center;
  vertical-align: middle;
  width: 90%;
}
.footer a {
  text-decoration: none;
  transition: all 0.2s;
  color: var(--text-color);
}
.footer a:hover {
  color: rgb(170, 214, 147);
}
.footer .footer-contact-infos {
  margin: 0.5rem 0;
}
.footer .social-media {
  justify-content: center;
  margin-top: 10px;
}
.footer .social-media img {
  width: 2rem;
  margin: 0.5rem 0.5rem;
  vertical-align: -moz-middle-with-baseline;
}
.footer .social-media a {
  width: 17%;
}

@media only screen and (min-width: 1280px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 25%;
    max-width: 25%;
    box-sizing: border-box;
  }
  .fxFlex-50-33md-50sm-100xs {
    flex: 1 1 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1279px) and (min-width: 960) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 33%;
    max-width: 33%;
    box-sizing: border-box;
  }
  .fxFlex-50-33md-50sm-100xs {
    flex: 1 1 33%;
    max-width: 33%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) and (min-width: 600px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
  .fxFlex-50-33md-50sm-100xs {
    flex: 1 1 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 599px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .fxFlex-50-33md-50sm-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EAEE,SAAA;EACA,WAAA;EACA,mCAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,wBAAA;AAAF;AAEE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AAGE;EAEE,YAAA;AAFJ;AAII;EACE,uBAAA;AAFN;AAME;EACE,UAAA;EACA,YAAA;AAJJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAJN;AAMM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;AAJR;AAMQ;EACE,UAAA;EACA,0BAAA;EACA,0BAAA;AAJV;AAOQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AALV;AAWE;EACE,gBAAA;EACA,sBAAA;AATJ;AAYE;EACE,UAAA;EACA,WAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAcE;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;AAbJ;AAgBE;EACE,qBAAA;EACA,oBAAA;EACA,wBAAA;AAdJ;AAgBI;EACE,yBAAA;AAdN;AAkBE;EACE,gBAAA;AAhBJ;AAmBE;EACE,uBAAA;EACA,gBAAA;AAjBJ;AAmBI;EACE,WAAA;EAEA,qBAAA;EACA,yCAAA;AAlBN;AAqBI;EACE,UAAA;AAnBN;;AA6BA;EAEE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EA5BF;EA+BA;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EA9BF;AACF;AAmCA;EAEE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EAnCF;EAsCA;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EArCF;AACF;AA4CA;EAEE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EA5CF;EA+CA;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EA9CF;AACF;AAoDA;EAEE;IAEE,cAAA;IACA,eAAA;IACA,sBAAA;EApDF;EAuDA;IAEE,cAAA;IACA,eAAA;IACA,sBAAA;EAtDF;AACF","sourcesContent":[".footer {\r\n  // position: relative;\r\n  bottom: 0;\r\n  width: 100%;\r\n  background-color: var(--background);\r\n  padding: 1rem;\r\n  border-top: 2px solid var(--mid-gray);\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  color: var(--text-color);\r\n\r\n  h4 {\r\n    text-align: center;\r\n    font-size: 10px;\r\n    margin: 10px 0 0 0;\r\n  }\r\n\r\n  svg {\r\n\r\n    padding: 4px;\r\n\r\n    path {\r\n      fill: var(--text-color);\r\n    }\r\n  }\r\n\r\n  .footer-content-container {\r\n    width: 70%;\r\n    margin: auto;\r\n\r\n    .fxLayout-row-wrap{\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      width: 100%;\r\n\r\n      .fxLayout-column{\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        flex-basis: 100%;\r\n        flex: 1;\r\n        \r\n        .best-logo{\r\n          width: 80%;\r\n          width: 197.75px !important;\r\n          height: 102.8px !important;\r\n        }\r\n\r\n        .inside-column-div {\r\n          display: flex;\r\n          flex-direction: column;\r\n          align-items: center;\r\n          justify-content: center;\r\n          text-align: center;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  mat-icon {\r\n    margin: 0 0.5rem;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  img {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n\r\n  .divider-h-spacing {\r\n    margin: 0 5rem;\r\n  }\r\n\r\n  .divider-v-spacing {\r\n    border: 1px solid var(--mid-gray);\r\n    border-radius: 2px;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  span {\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    width: 90%;\r\n  }\r\n\r\n  a {\r\n    text-decoration: none;\r\n    transition: all 0.2s;\r\n    color: var(--text-color);\r\n\r\n    &:hover {\r\n      color: rgba(170,214,147,255);\r\n    }\r\n  }\r\n\r\n  .footer-contact-infos {\r\n    margin: 0.5rem 0;\r\n  }\r\n\r\n  .social-media {\r\n    justify-content: center;\r\n    margin-top: 10px;\r\n\r\n    img {\r\n      width: 2rem;\r\n      //for smaller icons - margin: 0 0.5rem;\r\n      margin: 0.5rem 0.5rem;\r\n      vertical-align: -moz-middle-with-baseline;\r\n    }\r\n\r\n    a{\r\n      width: 17%;\r\n    }\r\n  }\r\n\r\n  // New code\r\n\r\n  \r\n}\r\n\r\n// Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width: 1280px) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n    flex: 1 1 25%;\r\n    max-width: 25%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-50-33md-50sm-100xs {\r\n\r\n    flex: 1 1 50%;\r\n    max-width: 50%;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 1280px i pogolemi od 960px (md uredi)\r\n@media only screen and (max-width: 1279px) and (min-width:960) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n    flex: 1 1 33%;\r\n    max-width: 33%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-50-33md-50sm-100xs {\r\n\r\n    flex: 1 1 33%;\r\n    max-width: 33%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n}\r\n\r\n\r\n\r\n// Media query za site uredi pomali od 960px i pogolemi od 600px (sm uredi)\r\n@media only screen and (max-width: 959px) and (min-width:600px) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n    flex: 1 1 50%;\r\n    max-width: 50%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-50-33md-50sm-100xs {\r\n\r\n    flex: 1 1 50%;\r\n    max-width: 50%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 600px (xs uredi)\r\n@media only screen and (max-width: 599px) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-50-33md-50sm-100xs {\r\n\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
